import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Rocket } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useGamesPaused, SOON_TEXT } from "../../lib/useGamesPaused";

export const LAUNCH_TEXT = "€12.99 per game, or 3 games for €30";

export const LaunchPanel = ({ card }) => {
  const [others, setOthers] = useState([]);
  const [picked, setPicked] = useState([card.id]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/stb/cards").then((r) => setOthers(r.data.filter((c) => c.status === "unpaid" && c.id !== card.id))).catch(() => {}); }, [card.id]);
  const toggle = (id) => setPicked((p) => (p.includes(id) ? p.filter((x) => x !== id) : p.length < 3 ? [...p, id] : p));
  const n = picked.length;
  const paused = useGamesPaused();
  const pay = () => {
    setBusy(true);
    api.post("/stb/launch", { card_ids: picked, origin_url: window.location.origin })
      .then((r) => { window.location.href = r.data.checkout_url; })
      .catch((e) => { toast.error(errMsg(e)); setBusy(false); });
  };
  return (
    <section className="border-2 border-slate-900 bg-lime-50 p-4 shadow-[4px_4px_0_0_#0f172a]" data-testid="stb-launch-panel">
      <div className="flex items-center gap-2 font-display text-xl font-black uppercase"><Rocket className="h-5 w-5" /> Launch your game</div>
      <p className="mt-1 text-sm text-slate-700">Your game is set up but not live yet. Pay once to launch it and get your share link – {LAUNCH_TEXT}. A 1% fee on money raised covers hosting and online play.</p>
      {others.length >= 2 && (
        <div className="mt-3 space-y-1.5 text-sm" data-testid="stb-launch-bundle">
          <div className="font-bold">Launching 3 games? Tick 2 more to pay €30 for all 3:</div>
          {others.map((c) => (
            <label key={c.id} className="flex items-center gap-2">
              <input type="checkbox" checked={picked.includes(c.id)} onChange={() => toggle(c.id)} disabled={!picked.includes(c.id) && n >= 3} data-testid={`stb-launch-pick-${c.id}`} />
              {c.title}
            </label>
          ))}
        </div>
      )}
      {paused && <p className="mt-3 border-2 border-slate-900 bg-amber-100 p-3 text-sm font-bold" data-testid="stb-launch-soon">{SOON_TEXT}</p>}
      <button type="button" disabled={busy || n === 2 || paused} onClick={pay} className="btn-blaze mt-3 px-5 py-3 text-sm disabled:cursor-not-allowed disabled:opacity-50" data-testid="stb-launch-pay">
        {paused ? "Coming soon" : busy ? "Opening payment…" : n === 3 ? "Pay €30 to launch 3 games" : n === 2 ? "Tick one more game for 3 for €30" : "Pay €12.99 to launch"}
      </button>
    </section>
  );
};
